export const REPORT_CATEGORIES = [
  ["Diabetes", "🩸"],
  ["Lipid Profile", "❤️"],
  ["Thyroid", "🦋"],
  ["Liver Function", "🧪"],
  ["Kidney Function", "🩺"],
  ["CBC", "🩸"],
  ["Urine", "💧"],
  ["Vitamin", "🧬"],
  ["Other", "📄"],
];
export const CATEGORY_EMOJI = Object.fromEntries(REPORT_CATEGORIES);

export const UPLOAD_STAGES = [
  "Uploading",
  "AI Extracting Laboratory Values",
  "Analyzing Report",
  "Detecting Report Type",
  "Renaming Report",
  "Saving Structured Data",
  "Updating AI Summary",
  "Completed",
];
